import React, { useState } from 'react';
import ReportsPanel from './ReportsPanel';
import InvoiceView from './InvoiceView';
import BuffingAdmin from './BuffingAdmin';

export default function AdminReportsPage({ user, onBack }) {
  const [subTab, setSubTab] = useState('Reports');
  const subTabs = ['Reports', 'Invoices', 'Buffing'];

  return (
    <div>
      {/* Sub-tab nav */}
      <div style={{ borderBottom: '2px solid #e5e7eb', background: '#f9fafb', padding: '0 24px' }}>
        <div style={{ display: 'flex', gap: 0 }}>
          {subTabs.map(t => (
            <button key={t} onClick={() => setSubTab(t)} style={{
              padding: '10px 20px', border: 'none', background: 'transparent',
              fontSize: 13, fontWeight: 600,
              color: subTab === t ? '#4A7A91' : '#9ca3af',
              borderBottom: subTab === t ? '2px solid #4A7A91' : '2px solid transparent',
              cursor: 'pointer', marginBottom: -2,
            }}>{t}</button>
          ))}
        </div>
      </div>

      <div>
        {subTab === 'Reports'  && <ReportsPanel />}
        {subTab === 'Invoices' && <InvoiceView user={user} onBack={() => setSubTab('Reports')} />}
        {subTab === 'Buffing'  && <BuffingAdmin />}
      </div>
    </div>
  );
}
